module.exports = __webpack_public_path__ + "64dd67b49c2c948ad5e886fd247c72f1.png";